import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7145680e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-12 lg:py-24" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "testimonials",
  class: "flex justify-center items-center"
}, [
  /*#__PURE__*/_createElementVNode("h1", { class: "lg:text-7xl text-4xl font-black text-center lg:mt-24 my-12 text-[#163537] dark:text-gray-200" }, " Testimonials ")
], -1))
const _hoisted_3 = { class: "relative max-w-7xl mx-auto px-2 sm:px-4 mt-8" }
const _hoisted_4 = { class: "overflow-hidden grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_5 = { class: "p-4 pt-6" }
const _hoisted_6 = { class: "mb-4 flex items-center gap-1" }
const _hoisted_7 = { class: "font-light text-[#163537] dark:text-gray-300 sm:text-base text-sm mb-4 pb-6 leading-relaxed break-words" }
const _hoisted_8 = { class: "flex items-center gap-3 border-t-2 dark:border-gray-700 pt-4" }
const _hoisted_9 = { class: "size-12 rounded-full bg-[#163537]/70 dark:bg-gray-600 border-4 dark:border-gray-600 flex items-center justify-center text-white font-bold text-lg" }
const _hoisted_10 = { class: "font-bold text-[#163537] dark:text-gray-200 sm:text-base text-sm" }
const _hoisted_11 = { class: "font-light text-[#56555e] dark:text-gray-400 sm:text-sm text-xs" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]

import { ref, onMounted, onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TestimonialsComp',
  setup(__props) {

const testimonials = [
  {
    quote:
      "Leo is an exceptional frontend developer who consistently delivers high-quality work. His attention to detail and ability to transform designs into beautiful, functional interfaces is impressive. Working with him has been a great experience.",
    name: "Stephen Udeh",
    role: "Senior Software Developer",
    company: "PathTech ",
    initials: "SU",
  },
  {
    quote:
      "Leo brought our vision to life with his technical expertise and creative problem-solving skills. He's responsive, professional, and always goes above and beyond to ensure the final product exceeds expectations. Highly recommended!",
    name: "Henry Valentine",
    role: "Mobile/Web Developer",
    company: "Crovr",
    initials: "HV",
  },
  {
    quote:
      "Working with Leo was a pleasure. His deep understanding of modern frontend technologies and best practices resulted in a fast, responsive, and user-friendly application. He's a reliable team player who consistently meets deadlines.",
    name: "Michael Chen",
    role: "CTO",
    company: "Startup Inc",
    initials: "MC",
  },
  {
    quote:
      "Leo's technical skills are top-notch, and his communication throughout the project was excellent. He transformed our complex requirements into an intuitive user interface that our users love. I would definitely work with him again.",
    name: "Safiyat Hamzat",
    role: "Founder",
    company: "SafiBest Fashion",
    initials: "SH",
  },
];

const currentIndex = ref(0);
let autoPlayInterval: ReturnType<typeof setInterval> | null = null;

// Calculate the maximum index based on screen size
const getMaxIndex = (): number => {
  if (typeof window === 'undefined') return testimonials.length - 1;
  
  const width = window.innerWidth;
  if (width >= 1024) {
    // lg screens: 3 cards per view
    return Math.max(0, testimonials.length - 3);
  } else if (width >= 640) {
    // sm screens: 2 cards per view
    return Math.max(0, testimonials.length - 2);
  } else {
    // mobile: 1 card per view
    return testimonials.length - 1;
  }
};

const nextSlide = () => {
  const maxIdx = getMaxIndex();
  if (currentIndex.value >= maxIdx) {
    currentIndex.value = 0;
  } else {
    currentIndex.value++;
  }
  resetAutoPlay();
};

const previousSlide = () => {
  const maxIdx = getMaxIndex();
  if (currentIndex.value <= 0) {
    currentIndex.value = maxIdx;
  } else {
    currentIndex.value--;
  }
  resetAutoPlay();
};

const resetAutoPlay = () => {
  if (autoPlayInterval) {
    clearInterval(autoPlayInterval);
  }
  startAutoPlay();
};

const startAutoPlay = () => {
  autoPlayInterval = setInterval(() => {
    nextSlide();
  }, 5000); // Change slide every 5 seconds
};

let resizeHandler: (() => void) | null = null;

onMounted(() => {
  startAutoPlay();
  
  // Update index on window resize
  resizeHandler = () => {
    const maxIdx = getMaxIndex();
    if (currentIndex.value > maxIdx) {
      currentIndex.value = maxIdx;
    }
  };
  
  window.addEventListener('resize', resizeHandler);
});

onUnmounted(() => {
  if (autoPlayInterval) {
    clearInterval(autoPlayInterval);
  }
  if (resizeHandler) {
    window.removeEventListener('resize', resizeHandler);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "flex transition-transform duration-500 ease-in-out",
          style: _normalizeStyle({ transform: `translateX(-${currentIndex.value * 100}%)` })
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(testimonials, (testimonial, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "min-w-full px-0 sm:px-2"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([
                'w-full rounded-md overflow-hidden border shadow-md hover:shadow-lg transition-shadow',
                index % 2 !== 0 ? 'bg-primary-gray/50 dark:bg-gray-800/50' : 'bg-white dark:bg-gray-800',
                'dark:border-gray-700'
              ])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                      return _createElementVNode("div", {
                        key: star,
                        class: "text-yellow-400 text-xl"
                      }, " ★ ")
                    }), 64))
                  ]),
                  _createElementVNode("p", _hoisted_7, " \"" + _toDisplayString(testimonial.quote) + "\" ", 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(testimonial.initials), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_10, _toDisplayString(testimonial.name), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(testimonial.role) + " • " + _toDisplayString(testimonial.company), 1)
                    ])
                  ])
                ])
              ], 2)
            ])
          }), 64))
        ], 4)
      ]),
      _createElementVNode("button", {
        onClick: previousSlide,
        class: "absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-12 bg-[#163537]/40 dark:bg-gray-700/40 text-white dark:text-gray-200 rounded-full p-3 hover:bg-[#1a4043] dark:hover:bg-gray-600 transition-colors shadow-lg z-10",
        "aria-label": "Previous testimonial"
      }, _hoisted_13),
      _createElementVNode("button", {
        onClick: nextSlide,
        class: "absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-12 bg-[#163537]/40 dark:bg-gray-700/40 text-white dark:text-gray-200 rounded-full p-3 hover:bg-[#1a4043] dark:hover:bg-gray-600 transition-colors shadow-lg z-10",
        "aria-label": "Next testimonial"
      }, _hoisted_15)
    ])
  ]))
}
}

})